import React, { type ElementType, useRef } from "react";

import type { ReactNode } from "react";

import { CheckIcon } from "components/atoms/Icons";
import type { IconSize } from "components/atoms/Icons/BaseIcon";

import * as Styled from "./PopupMenu.styled";

export interface PopupMenuItemProps
  extends React.HTMLAttributes<HTMLButtonElement> {
  forwardedAs?: ElementType;
  href?: string;
  target?: string;
  isDisabled?: boolean;
  hasIcon?: boolean;
  iconSize?: keyof typeof IconSize;
  icon?: ReactNode;
  border?: boolean;
  isChecked?: boolean;
  withBorderTop?: boolean;
  isCreate?: boolean;
  isDelete?: boolean;
  isClickable?: boolean;
  blurOnClick?: boolean;
}

export { PopupMenuLabel } from "./PopupMenu.styled";

export const PopupMenuItem: React.FC<PopupMenuItemProps> = ({
  forwardedAs = "button",
  children,
  hasIcon,
  icon,
  iconSize = "xs",
  isDisabled = false,
  isChecked = false,
  withBorderTop,
  isDelete = false,
  isCreate = false,
  isClickable = true,
  blurOnClick = false,
  onClick,
  ...props
}) => {
  const ref = useRef<HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event as any);
    if (blurOnClick) {
      ref.current?.blur();
    }
  };

  return (
    <Styled.PopupMenuLabel
      ref={ref}
      $clickable={isClickable}
      $create={isCreate}
      $delete={isDelete}
      $withBorderTop={withBorderTop}
      disabled={isDisabled}
      forwardedAs={forwardedAs}
      onClick={handleClick}
      {...props}
    >
      {(hasIcon || icon) && (
        <Styled.MenuItemIcon>
          {icon || (isChecked && <CheckIcon size={iconSize} />)}
        </Styled.MenuItemIcon>
      )}
      {children}
    </Styled.PopupMenuLabel>
  );
};
